<button
  [matMenuTriggerFor]="panel.menu"
  mat-stroked-button
  color="primary"
>
  <span>Manage Budget</span>
  <fa-icon class="ml-a" [icon]="['fas', 'chevron-down']"></fa-icon>
</button>
<menu-panel #panel [items]="items" [backdropClass]="'manage-budget-panel'"></menu-panel>

<ng-template #CABCTemplate>
  <div class="captcha-content">
    <div class="selection-area">
      <ul class="selection-list">
        <li *ngFor="let item of selectionList">
          <mat-checkbox
            color="primary"
            [(ngModel)]="item.selected"
            (change)="onCheckboxChange($event.checked, item)"
            class="selection-checkbox"
            [disabled]="item.disabled"
            >{{ item.label }}
        </mat-checkbox>

        </li>
      </ul>
        
    </div>

    <div class="formula-area">
      <cab-configuration-formula-builder
      [selectedItems]="selectedItems"
      [isOnBudgetPage]="true"
      [nonHighlightedFormulaItem]="nonHighlightedFormulaItem"
      >

      </cab-configuration-formula-builder>
    </div>
  </div>
</ng-template>